import { render, staticRenderFns } from "./barra-lateral-buscador.vue?vue&type=template&id=36a13244&scoped=true&"
import script from "./barra-lateral-buscador.vue?vue&type=script&lang=ts&"
export * from "./barra-lateral-buscador.vue?vue&type=script&lang=ts&"
import style0 from "./barra-lateral-buscador.vue?vue&type=style&index=0&id=36a13244&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a13244",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VIcon,VRow,VTextField})
